import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import FormsTextareaMaterial from "@olmokit/core/forms/textarea/material";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import FormUploadFile from "@olmokit/core/forms/file/olmominimal";
import { $, on } from "@olmokit/dom";
import { countryEndpoint, hideProject, showProject } from "components/Form";
import { dataLayerFillingForm, dataLayerForm } from "components/Datalayer";
import { salesforceCommunication } from "components/Form";
import { globalConf } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";
import axios from 'axios';
import "./Other.scss";

/**
 * Component: FormProductCart
 */
export function FormOther() {
  console.log("FormProduct mounted.");

  dataLayerFillingForm('#contactother .of:el', 'Form Other')

  const $container = $('.FormOther: .of:country');
  const $country = $('select', $container);

  on($country, 'change', () => {
    countryEndpoint(".FormOther:", $country.value);
  });

  const $jobcontainer = $('.FormOther: .of:job');
  const $jobfield = $('select', $jobcontainer);
  const $projcontainer = $('.FormOther: .of:project');
  const $projfield = $('select', $projcontainer);
  const $mqcontainer = $('.FormOther: .of:projectmq');
  const $yearcontainer = $('.FormOther: .of:projectyear');

  on($jobfield, 'change', () => {
    if ($jobfield.value == 'Press Stampa') {
      hideProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    } else {
      $projcontainer.style.display = 'block';
      showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    }
  });
  on($projfield, 'change', () => {
    showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
  })

  let ip = '';

  const olmoforms = Olmoforms(".FormOther:", {
    before: async (formData) => {
      console.log('step 1');
      console.log(formData);

      const $localcheck = $('#of-8-localcheck');
      if ($localcheck.value !== '') {
        console.log('stopped');
        olmoforms.boot(); // Halts submission
        return Promise.reject("Local check failed");
      }

      try {
        console.log('detectip');
        const { data } = await post('detectip', {
          data: { item: '$minimal' }
        });
        console.log('step 2');        
        ip = data;

        const token = await grecaptcha.execute('6Lf-wxorAAAAAIdTqMQ_Ah0OHludYUF6ga-iDaPC', { action: 'submit' });
        console.log('step 3');

        await axios.post(globalConf.cmsApiUrl + '/recaptcha', {
          token,
          ip,
        });

        console.log('step 4');
        console.log('recaptcha done');
      } catch (error) {
        console.error('step ERROR', error);
        olmoforms.boot(); // Prevents submit if reCAPTCHA or detectip fails
        return Promise.reject("Hook before failed");
      }

      console.log('step 5 (end)');

    },
    sent: (formData) => {
      dataLayerForm("form sent", formData, "Form Other", $('#of-3-usertype').value, $('#of-3-requesttype').value);
      console.log('sent', formData);
      console.log('step 6');

      axios.post(globalConf.cmsApiUrl + '/formscompiler', {
        email: formData['formData']['email'],
        ip: ip,
      })
        .then(() => {
          console.log('step 7');
          console.log('formscompiler done');
        })
        .catch((error) => {
          console.log(error);
        });

      salesforceCommunication(formData, "Form Other");

    },
    failed: (instance) => dataLayerForm("form_error", '', "Form Other", $('#of-3-usertype').value, $('#of-3-requesttype').value)
  });

  FormsInputMaterial();
  Dependency(".FormOther:");
  FormsSelectMaterial();
  FormUploadFile();
  FormsTextareaMaterial();

  return {
    destroy() {
      olmoforms.destroy();
    },
  };


}
